export default __webpack_public_path__ + "static/media/fi.dd9b4eb9.svg";